module.exports = __webpack_public_path__ + "img/EXP.bc583a29.svg";